<div class="severity-level-contacts-grid shadow-sm">
  @for (row of severityLevelContacts; let index = $index; track index) {
    <!-- col-1: severity ── spans all sub-rows -->
    <div
      class="severity-level-contacts-grid__cell border-b border-r col-start-1"
      [style.grid-row]="'span ' + severityLevelContactRowSpan(row)"
      [class.pair]="index % 2"
    >
      @if (row.link) {
        <a
          matTooltip="Go to definition"
          class="noc-policy__link"
          [innerHTML]="row.severity"
          [fragment]="row.link"
          [routerLink]="[]"
        ></a>
      } @else {
        <span
          class="text-[var(--noc-policy--color-accent)]"
          [innerHTML]="row.severity"
        ></span>
      }
    </div>

    <!-- col-4: shared e-mail ── also spans all sub-rows -->
    @if (row['generalEmail']; as generalEmail) {
      <div
        class="severity-level-contacts-grid__cell border-b col-start-4"
        [style.grid-row]="'span ' + severityLevelContactRowSpan(row)"
        [class.pair]="index % 2"
      >
        <a class="noc-policy__link" [href]="'mailto:' + generalEmail">
          {{ generalEmail }}
        </a>
      </div>
    }

    <!-- one row per contact -->
    @for (contact of row.contacts; track $index) {
      <!-- col-2: name -->
      <div
        class="severity-level-contacts-grid__cell border-b border-r col-start-2"
        [class.pair]="index % 2"
      >
        {{ contact.name }}
        @if (contact['title']; as title) {
          <span class="opacity-70"> ({{ title }}) </span>
        }
      </div>

      <!-- col-3: phones -->
      <div
        class="severity-level-contacts-grid__cell border-b border-r col-start-3 flex flex-col gap-2"
        [class.pair]="index % 2"
      >
        @for (phone of contact.phones; track $index) {
          <div
            class="flex gap-2"
            [matTooltip]="phone.type === 'CEL' ? 'Cellphone' : 'Office'"
          >
            <span class="h-4 w-4 inline-block">
              <mat-icon class="scale-75 opacity-75">
                {{ phone.type === 'CEL' ? 'smartphone' : 'phonelink' }}
              </mat-icon>
            </span>
            <a
              class="noc-policy__link"
              [href]="'tel:' + phone.number.split(' ').join('')"
            >
              {{ phone.number }}
            </a>
          </div>
        }
      </div>

      <!-- col-4: individual e-mail (if no generalEmail) -->
      @if (!row['generalEmail']) {
        <div
          class="severity-level-contacts-grid__cell border-b col-start-4"
          [class.pair]="index % 2"
        >
          @if (contact['email']; as email) {
            <a class="noc-policy__link" [href]="'mailto:' + email">
              {{ email }}
            </a>
          } @else {
            &nbsp;
            <!-- placeholder -->
          }
        </div>
      }
    }
  }
</div>
